




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { PolicyModel } from '@/app/shared/models';
@Component
export default class FormPolicyComponent extends Vue {
  @Prop(Object) readonly data!: PolicyModel;
  private menu1 = false;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
}
